export default {
      id: "icon-sorting-down-usage",
      viewBox: "0 0 8 15",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-sorting-down",
      toString: function () {
        return this.url;
      }
    }